import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Arrow direction for trajectory */
export type TrajectoryArrowDirection = 'start' | 'end' | 'both' | 'none';

/** Trajectory feature parameters */
export interface TrajectoryParams {
  /** Reference to parent function element */
  of: string;
  /** X-coordinate where trajectory starts */
  xStart: number;
  /** X-coordinate where trajectory ends */
  xEnd: number;
  /**
   * Perpendicular distance from the parent curve (default 0.5).
   * Positive = offset in normal direction (outward for convex curves).
   */
  distance?: number;
  /** Direction of the arrow indicator */
  arrowDirection?: TrajectoryArrowDirection;
}

// =============================================================================
// DEFAULTS
// =============================================================================

export const TRAJECTORY_DEFAULT_PARAMS: Omit<TrajectoryParams, 'of'> = {
  xStart: -2,
  xEnd: 2,
  distance: 0.5,
  arrowDirection: 'end',
};

/**
 * Default theme for trajectory feature.
 * Uses core curve defaults - only specify color.
 */
export const TRAJECTORY_DEFAULTS: FeatureStyleNode = {
  curve: { color: 'amber' },
};
